/* eslint-disable @typescript-eslint/no-explicit-any */
import { jdiColorFetch } from '../colorFetchV2';
import { NewGiftActivityDto, NewUserGiftQueryDto, NewUserPriceResponseVO } from './gift.interface';

interface Response<T> {
  success: boolean;
  code: string;
  msg: string;
  data: T;
  traceId: string;
  result: boolean;
}

interface NewUserGiftQuery {
  scene: 'QUERY' | 'QUERY_RECEIVE';
}

// 查询礼包 https://cf.jd.com/pages/viewpage.action?pageId=629977547
export const giftQuery = (requestData?: any): Promise<Response<NewGiftActivityDto>> => {
  return jdiColorFetch(
    `marketing_interact_getGiftPack`,
    {
      method: 'get',
      bodyQuery: { ...requestData },
    },
    { isCommonArea: false },
  )
    .then((response: any) => response)
    .catch((error: any) => error);
};

export const newUserGiftQuery = (
  data: NewUserGiftQuery,
): Promise<Response<NewUserGiftQueryDto>> => {
  return jdiColorFetch(`marketing_interact_getGiftPack`, {
    method: 'get',
    bodyQuery: data,
  })
    .then((response: any) => response)
    .catch((error: any) => error);
};

export const newUserProductPoolQuery = (data: any): Promise<Response<NewUserPriceResponseVO>> => {
  return jdiColorFetch(`marketing_interact_getNewUserItems`, {
    method: 'get',
    bodyQuery: { ...data },
  })
    .then((response: any) => response)
    .catch((error: any) => error);
};
